module.exports = __webpack_public_path__ + "fonts/OpenSans400.a9bb56e2.eot";